

import {requestCommon} from '../libs/axios'
  /*获取增值服务详情*/
export const getServicesDetail = (goodsId) => requestCommon.post(`/paralegal/privilegeGood/getPrivilegeGoodsByGoodsId/${goodsId}`);

  /*获取当前律师对应 某个会员权益配置的值.*/
export const getServicesDetailValue = (data) => requestCommon.post(`/paralegal/vipPrivilege/getVipPrivilegeValue`, data);

  /*查询增值服务订单支付结果*/
export const getServicesPayResult = (orderNo) => requestCommon.post(`/order/orderValueAdded/query/${orderNo}`);

  /*增值服务购买重新发送验证码 valueAddedOrderNo*/
export const getServicesCode = (data) => requestCommon.post(`/order/orderValueAdded/sms/sendSmsAgain`,data);

  /*支付验证码校验 code data*/
export const getServicesCheck = (data) => requestCommon.post(`/order/orderValueAdded/pay/smsCheck`,data);

  /*增值服务服务支付 并 创建订单*/
export const getServicesPay = (data) => requestCommon.post(`/order/orderValueAdded/pay`,data);

  /*是否可以延长*/
export const caseisExtend = (caseSourceId) => requestCommon.post(`/paralegal/caseSource/isExtend/${caseSourceId}`);
